export { default } from './alert-circle'
